/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.19/esri/copyright.txt for details.
*/
import{glsl as e}from"../../shaderModules/interfaces.js";import{TextureCoordinateAttribute as t}from"./TextureCoordinateAttribute.glsl.js";import{TextureAtlasLookup as r}from"../util/TextureAtlasLookup.glsl.js";function u(u,a){u.include(t,a),u.fragment.code.add(e`
  struct TextureLookupParameter {
    vec2 uv;
    ${a.supportsTextureAtlas?"vec2 size;":""}
  } vtc;
  `),1===a.attributeTextureCoordinates&&u.fragment.code.add(e`
      vec4 textureLookup(sampler2D tex, TextureLookupParameter params) {
        return texture2D(tex, params.uv);
      }
    `),2===a.attributeTextureCoordinates&&(u.include(r),u.fragment.code.add(e`
    vec4 textureLookup(sampler2D tex, TextureLookupParameter params) {
        return textureAtlasLookup(tex, params.size, params.uv, vuvRegion);
      }
    `))}export{u as VertexTextureCoordinates};
